/* ============================================================
   MH PREMIUM — vanilla scroll-reveal + hero parallax + stat count-up
   No libraries. Transform/opacity only. Respects reduced-motion.
   The html.mh-anim-ready class is set by an inline head script
   BEFORE paint (so reveal targets are hidden with no flash).
   This file only ADDS .mh-is-visible + drives parallax + count-up.

   SAFETY: sets window.__mhBooted = true the instant it executes, so
   the inline <head> failsafe timer knows the reveal engine is alive.
   If this file is blocked / 404s / throws, the head failsafe removes
   .mh-anim-ready after ~2500ms and everything becomes visible — worst
   case is "no animations", never "no content" (matters for Googlebot,
   which executes JS while indexing).
   ============================================================ */
(function () {
  'use strict';

  // Signal to the head-guard failsafe that the reveal engine is alive.
  try { window.__mhBooted = true; } catch (e) {}

  var doc = document.documentElement;

  // Ultimate fallback: drop the hiding class so ALL content shows.
  function revealAll() {
    try { doc.classList.remove('mh-anim-ready'); } catch (e) {}
  }

  // If the head guard didn't run (or reduced-motion), do nothing —
  // everything stays visible.
  if (!doc.classList.contains('mh-anim-ready')) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ---- Scroll reveal ---- */
  var REVEAL_SELECTORS = [
    '[id*="custom_liquid_XLGbTn"] .mh-catalog__header',
    '[id*="custom_liquid_XLGbTn"] .mh-grid > .mh-card',
    '[id*="trust_bar_4col"] .mh-t4-item',
    '[id*="1771018635bb901d44"] .jdgm-cards-wrapper',
    '[id*="custom_liquid_tipsPromo"] .mht2-head',
    '[id*="custom_liquid_tipsPromo"] .mht2-card',
    '[id*="custom_liquid_kingPromo"] .mhk2-copy',
    '[id*="custom_liquid_kingPromo"] .mhk2-img',
    '[id*="section_j3AAXA"]',
    '[id*="custom_liquid_XRexTm"] .mh-faq__card'
  ].join(',');

  function reveal(el) { el.classList.add('mh-is-visible'); }

  function initReveal() {
    try {
      var els = Array.prototype.slice.call(document.querySelectorAll(REVEAL_SELECTORS));
      if (!els.length) return;

      if (!('IntersectionObserver' in window)) {
        els.forEach(reveal); // no IO support -> just show
        return;
      }

      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          // Stagger children that share a parent (cards, trust items) by DOM
          // index, 80ms step, cap 6.
          var idx = 0, sib = el.previousElementSibling;
          while (sib) {
            if (sib.classList && (sib.classList.contains('mh-card') ||
                sib.classList.contains('mht2-card') ||
                sib.classList.contains('mh-t4-item'))) idx++;
            sib = sib.previousElementSibling;
          }
          el.style.transitionDelay = (Math.min(idx, 6) * 80) + 'ms';
          reveal(el);
          obs.unobserve(el);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

      els.forEach(function (el) { io.observe(el); });
    } catch (e) {
      // On ANY failure, never leave content hidden.
      try { Array.prototype.slice.call(document.querySelectorAll(REVEAL_SELECTORS)).forEach(reveal); }
      catch (_) { revealAll(); }
    }
  }

  /* ---- Stat count-up (King: 226g / 2019 / 100%) ---- */
  function finalize(el) {
    el.textContent = el.getAttribute('data-count-to') + (el.getAttribute('data-suffix') || '');
  }

  function countUp(el) {
    var to = parseFloat(el.getAttribute('data-count-to'));
    if (isNaN(to)) { finalize(el); return; }
    var suffix = el.getAttribute('data-suffix') || '';
    // Lock the stat box to its final width BEFORE counting (el still shows the
    // final HTML value here), so shrinking the number to "0" can't shift the
    // sibling stats in the flex row — CLS-safe.
    try { var box = el.parentNode; if (box && !box.style.minWidth) { box.style.minWidth = box.offsetWidth + 'px'; } } catch (e) {}
    var dur = 1200, start = null;
    function ease(t) { return 1 - Math.pow(1 - t, 3); } // ease-out cubic
    function frame(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      el.textContent = Math.round(to * ease(p)) + suffix;
      if (p < 1) { window.requestAnimationFrame(frame); }
      else { el.textContent = to + suffix; } // exact final value
    }
    window.requestAnimationFrame(frame);
  }

  function initCountUp() {
    try {
      var stats = Array.prototype.slice.call(document.querySelectorAll('.mh-countup'));
      if (!stats.length) return;

      if (!('IntersectionObserver' in window)) { stats.forEach(finalize); return; }

      var cio = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          countUp(entry.target);
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.15 });

      stats.forEach(function (s) { cio.observe(s); });
    } catch (e) {
      // On failure, snap to the final (already-rendered) values.
      try { Array.prototype.slice.call(document.querySelectorAll('.mh-countup')).forEach(finalize); } catch (_) {}
    }
  }

  /* ---- Hero parallax (transform-only, rAF) ---- */
  function initParallax() {
    try {
      var hero = document.querySelector('[id*="custom_liquid_XLGbTn"] .mh-hero2__right');
      if (!hero) return;
      if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) return; // skip on mobile

      var ticking = false;
      var maxShift = 60; // px cap

      function update() {
        var rect = hero.getBoundingClientRect();
        // progress of hero through viewport; only while roughly in view
        if (rect.bottom < -200 || rect.top > window.innerHeight + 200) { ticking = false; return; }
        var shift = Math.max(-maxShift, Math.min(maxShift, (window.scrollY || window.pageYOffset) * 0.12));
        hero.style.transform = 'translate3d(0,' + shift + 'px,0)';
        ticking = false;
      }
      function onScroll() {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    } catch (e) {}
  }

  function boot() {
    try {
      initReveal();
      initCountUp();
      initParallax();
    } catch (e) {
      revealAll(); // never leave content hidden
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
